<div id="card-style">
  <p-card header="Question">
    <div class="formgrid grid m-3">
      <div class="field col-12">
        <label for="firstname6">Question</label>
        <input
          id="firstname6"
          type="text"
          [(ngModel)]="question.title"
          maxlength="50"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
        />
        <small class="text-gray-500 block mt-1">Maximum 50 characters allowed</small>
      </div>
      <div class="field col-12">
        <label for="address">Full Question</label>
        <p-editor
          #fullTextEditor
          [(ngModel)]="question.fullText"
          [style]="{ height: '220px' }"
          (onInit)="onEditorInit()"
          (onUpload)="onImageUpload($event)"
        >
        </p-editor>
      </div>
      <div class="field col-12 md:col-4">
        <label for="st">Question Category</label>
        <select
          id="st"
          [(ngModel)]="question.category"
          (change)="changeQuestionCategory()"
          class="w-full text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round outline-none focus:border-primary"
          style="appearance: auto"
        >
          <option *ngFor="let Category of questionCategories" [value]="Category.code">
            {{ Category.name }}
          </option>
        </select>
      </div>
      <div class="field col-12 md:col-4">
        <label for="state">Difficulty</label>
        <select
          id="state"
          [(ngModel)]="question.level"
          class="w-full text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round outline-none focus:border-primary"
          style="appearance: auto"
        >
          <option>Easy</option>
          <option>Medium</option>
          <option>Hard</option>
        </select>
      </div>
      <div class="field flex flex-column col-12 md:col-4">
        <label for="st">Answer Option</label>
        <select
          *ngIf="
            !question.category || question.category !== QUESTION_TYPES.MCQ_MULTIPLE_CORRECT;
            else multiSelectSub
          "
          id="st"
          [(ngModel)]="question.answerOption"
          [disabled]="question.category === QUESTION_TYPES.SUBJECTIVE"
          class="answer-option-select w-full text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round outline-none focus:border-primary"
          style="appearance: auto"
        >
          <option *ngFor="let quxe of question.options | keyvalue" [value]="quxe.key">
            {{ quxe.key }}
          </option>
        </select>
        <small
          *ngIf="question.category === QUESTION_TYPES.SUBJECTIVE"
          class="answer-option-disabled-message"
        >
          Not applicable for subjective questions
        </small>
        <ng-template #multiSelectSub>
          <p-multiSelect
            [options]="optionMultiSelect"
            [(ngModel)]="selectedMultiSelect"
            placeholder="Select Options"
            optionLabel="optionName"
            [showClear]="true"
            class="w-full"
          />
        </ng-template>
      </div>
      <ng-container>
        <ng-container *ngFor="let que of question.options | keyvalue">
          <div *ngIf="question.numberOfOption !== 0" class="field col">
            <label for="{{ que.key }}">OPTION {{ que.key }}</label>
            <input
              id="{{ que.key }}"
              type="text"
              [(ngModel)]="que.value"
              (change)="onOptionchange(que.key, $event)"
              class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
            />
          </div>
        </ng-container>
      </ng-container>
      <div class="field col-12 flex">
        <div class="field col-4 flex flex-column">
          <label for="tags">Tags</label>
          <p-chips
            class="w-full p-fluid"
            id="tags"
            [(ngModel)]="question.tags"
            separator=","
            (onAdd)="onTagchange()"
            (onRemove)="onTagchange()"
          ></p-chips>
        </div>

        <div class="field col-4 flex flex-column">
          <label for="subjectSelect">Subject</label>
          <p-dropdown
            id="subjectSelect"
            [options]="subjects"
            optionLabel="name"
            optionValue="id"
            [(ngModel)]="selectedSubjectId"
            (onChange)="onSubjectChange()"
            placeholder="Select Subject"
            class="w-full"
          ></p-dropdown>
        </div>

        <div class="field col-4 flex flex-column">
          <label for="topicSelect">Topics</label>
          <p-multiSelect
            id="topicSelect"
            [options]="topicsForSelectedSubject"
            optionLabel="name"
            optionValue="id"
            [(ngModel)]="selectedTopicIds"
            placeholder="Select Topics"
            [emptyMessage]="
              selectedSubjectId ? 'No topics found for this subject' : 'Select a subject first'
            "
            [showClear]="true"
            class="w-full"
          ></p-multiSelect>

          <label class="mt-2">Default Tags</label>
          <div class="subTopicContainer flex gap-2">
            <span *ngIf="!selectedSubjectId && selectedTopicIds.length === 0">
              Select Subject and Topics
            </span>
            <ng-container *ngIf="selectedSubjectId || selectedTopicIds.length > 0">
              <p-tag
                *ngIf="selectedSubjectId"
                severity="secondary"
                [value]="getSubjectName()"
              ></p-tag>

              <ng-container *ngFor="let topic of topicsForSelectedSubject">
                <p-tag
                  *ngIf="selectedTopicIds.includes(topic.id)"
                  severity="secondary"
                  [value]="topic.name"
                ></p-tag>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="field col-12">
        <label for="solution">Solution/Reasoning</label>
        <p-editor
          #solutionEditor
          [(ngModel)]="question.solution"
          [style]="{ height: '220px' }"
          (onInit)="onEditorInit()"
          (onUpload)="onImageUpload($event)"
        >
        </p-editor>
      </div>
      <div class="right-0">
        <button
          type="button"
          style="background-color: #3e53a0; color: white"
          class="border-primary-500 px-3 py-2 m-1 text-base border-1 border-solid border-round cursor-pointer transition-all transition-duration-200 hover:bg-primary-600 hover:border-primary-600 active:bg-primary-700 active:border-primary-700"
          (click)="cancel()"
        >
          Cancel
        </button>
        <button
          *ngIf="!isFromExam"
          type="button"
          style="background-color: #3e53a0; color: white"
          class="border-primary-500 px-3 py-2 m-1 text-base border-1 border-solid border-round cursor-pointer transition-all transition-duration-200 hover:bg-primary-600 hover:border-primary-600 active:bg-primary-700 active:border-primary-700"
          (click)="save()"
        >
          Save
        </button>
        <button
          *ngIf="isFromExam"
          type="button"
          style="background-color: #3e53a0; color: white"
          class="border-primary-500 px-3 py-2 m-1 text-base border-1 border-solid border-round cursor-pointer transition-all transition-duration-200 hover:bg-primary-600 hover:border-primary-600 active:bg-primary-700 active:border-primary-700"
          (click)="duplicate()"
        >
          Save as Copy
        </button>
        <button
          *ngIf="showDuplicateBtn && !isFromExam"
          type="button"
          style="background-color: #3e53a0; color: white"
          class="border-primary-500 px-3 py-2 m-1 text-base border-1 border-solid border-round cursor-pointer transition-all transition-duration-200 hover:bg-primary-600 hover:border-primary-600 active:bg-primary-700 active:border-primary-700"
          (click)="duplicate()"
        >
          Duplicate
        </button>
      </div>
    </div>
  </p-card>
</div>
<p-dialog
  header="Question Duplicated"
  [modal]="true"
  [(visible)]="visible"
  [style]="{ width: '60rem' }"
>
  <div *ngIf="question.title">
    You have Copied the Question <strong>{{ question.title.slice(0, -7) }}</strong> and now You are
    making changes in that question and it will not affect the previous question!!!
  </div>
</p-dialog>
